import type {
  MonthlySheetData,
  TaskListAbsenceData,
  TaskListElement,
  TaskListElementData,
} from 'shared/graphql/graphql'
import { TASK_TYPES } from '../../constants'
import { TASK_DATA_TYPE_NAMES } from './constants'

export const isAbsenceRequestTaskData = (taskData?: TaskListElementData): taskData is TaskListAbsenceData =>
  taskData?.__typename === TASK_DATA_TYPE_NAMES.taskListAbsenceData ||
  (taskData?.__typename as unknown) === TASK_DATA_TYPE_NAMES.absenceData

export const isMonthlySheetTask = (taskData?: TaskListElementData): taskData is MonthlySheetData =>
  taskData?.__typename === TASK_DATA_TYPE_NAMES.monthlySheetData

export const isSharedUserDataTask = (task?: TaskListElement): task is TaskListElement =>
  task?.taskType === TASK_TYPES.shareUserData

export const isShiftUpdateTask = (task?: TaskListElement): task is TaskListElement =>
  task?.taskType === TASK_TYPES.shiftUpdate

export const isSecuredConnectionTask = (task?: TaskListElement): task is TaskListElement =>
  task?.taskType === TASK_TYPES.secureConnection
